module.exports = __webpack_public_path__ + "static/img/noBody.e9ace2e2.png";